import { LOGIN_PATH, NAME_SPACE, RESET_PASSWORD_PATH, VERIFY_DISCOUNT_STATUS_PATH } from "constants/app-paths"

export const getPublicPaths = () => {
  const PUBLIC_ROUTES = [LOGIN_PATH, RESET_PASSWORD_PATH, VERIFY_DISCOUNT_STATUS_PATH]
  return NAME_SPACE.reduce((acc, ns) => {
    PUBLIC_ROUTES.forEach(route => {
      acc.push(`/${ns}${route}`)
    })
    return acc
  }, [])
}
